import React from "react";
import styles from "./pre-pins-toggle.module.scss";

interface PrePinsToggleProps {
  showPre: boolean;
  onToggle: (showPre: boolean) => void;
  className?: string;
  mobileVariant?: boolean;
  alwaysShowLegend?: boolean;
  onApply?: () => void;
  applyLabel?: string;
}

const PrePinsToggle: React.FC<PrePinsToggleProps> = ({
  showPre,
  onToggle,
  className = "",
  mobileVariant = false,
  alwaysShowLegend = false,
  onApply,
  applyLabel = "Apply"
}) => {
  const handleToggle = () => {
    onToggle(!showPre);
  };

  return (
    <div className={`${styles.preToggleContainer} ${className} ${mobileVariant ? styles.mobileVariant : ""}`}>
      <div className={styles.preToggleHeader}>
        <span className={styles.preToggleLabel}>
          PRE pins {showPre ? "ON" : "OFF"}
        </span>
        <div
          className={`${styles.toggleSwitch} ${
            showPre ? styles.toggleOn : styles.toggleOff
          }`}
          onClick={handleToggle}
        >
          <div className={styles.toggleHandle}></div>
        </div>
      </div>
      {(alwaysShowLegend || showPre) && (
        <div className={styles.preToggleLegend}>
          <div className={styles.legendItem}>
            <img
              src="/images/box-red-pin.png"
              alt="sold"
              width={20}
              height={15}
              className={styles.legendIcon}
            />
            <span>Sold once or Double Pin</span>
          </div>
          <div className={styles.legendItem}>
            <img
              src="/images/box-black-pin.png"
              alt="purchased"
              width={20}
              height={15}
              className={styles.legendIcon}
            />
            <span>Purchased and not resold</span>
          </div>
        </div>
      )}
      {onApply && (
        <button type="button" className={styles.applyButton} onClick={onApply}>
          {applyLabel}
        </button>
      )}
    </div>
  );
};

export default PrePinsToggle;
